import Vue from 'vue'
import { weixinReady, is } from '@didi/webx-js'
import Popup from './popup.vue'

export const mpGuide = () => {
  if (is('weixin') && !is('miniprogram')) {
    weixinReady(() => {
      Vue.config.ignoredElements = ['wx-open-launch-weapp']
      const _popup = new Vue({
        render(h) {
          return h(Popup)
        },
      })
      const component = _popup.$mount()
      document.body.appendChild(component.$el)
    })
  }
}
